import ContentJustified, { HTMLContent } from "./ContentJustified";

export { HTMLContent };
export default ContentJustified;
